module.exports = __webpack_public_path__ + "img/volumetrie_50.11144112.png";